import { gql } from "@apollo/client";

export const GET_ALL_CONTATCTS = gql`
query GetAllContacts($limit: Int!) {
    getAllContacts(limit: $limit) {
      Agents {
        contact_id
        contact_type
        arcimedes_row_id
        first_name
        last_name
        phone
        cell_phone
        email
        firm
        agent
        agent_firm
        status
        company_name
        company_address
        company_city
        company_state
        company_zip
        type
        notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
        profile
        category
        single_tenant_subcategory
        multi_tenant_subcategory
        market
        price_min
        price_max
        cap_rate_min
        cap_rate_max
        strive_agent
        strive_agent_last_name
        last_modified
        deleted
        hsc_follow_up
        name
        city
        state
        contact_name
        contact_phone
        contact_email
        linkedin
        description
        photo
        credentials
        is_agent
        is_admin
        visible_on_website
        visible_on_bov
        starting_date
        termination_date
        yrs_at_strive
        birth_date
        age
        on_phones
        in_pool
        first_listing
        first_closing
        address
        territory
        w4_form
        w9_form
        payroll_form
        ca_form
        it_policy_form
        trade_secrets_form
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      Sellers {
        contact_id
        contact_type
        arcimedes_row_id
        first_name
        last_name
        phone
        cell_phone
        email
        firm
        agent
        agent_firm
        status
        company_name
        company_address
        company_city
        company_state
        company_zip
        type
           notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
        profile
        category
        single_tenant_subcategory
        multi_tenant_subcategory
        market
        price_min
        price_max
        cap_rate_min
        cap_rate_max
        strive_agent
        strive_agent_last_name
        last_modified
        deleted
        hsc_follow_up
        name
        city
        state
        contact_name
        contact_phone
        contact_email
        linkedin
        description
        photo
        credentials
        is_agent
        is_admin
        visible_on_website
        visible_on_bov
        starting_date
        termination_date
        yrs_at_strive
        birth_date
        age
        on_phones
        in_pool
        first_listing
        first_closing
        address
        territory
        w4_form
        w9_form
        payroll_form
        ca_form
        it_policy_form
        trade_secrets_form
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      Buyers {
        contact_id
        contact_type
        arcimedes_row_id
        first_name
        last_name
        phone
        cell_phone
        email
        firm
        agent
        agent_firm
        status
        company_name
        company_address
        company_city
        company_state
        company_zip
        type
           notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
        profile
        category
        single_tenant_subcategory
        multi_tenant_subcategory
        market
        price_min
        price_max
        cap_rate_min
        cap_rate_max
        strive_agent
        strive_agent_last_name
        last_modified
        deleted
        hsc_follow_up
        name
        city
        state
        contact_name
        contact_phone
        contact_email
        linkedin
        description
        photo
        credentials
        is_agent
        is_admin
        visible_on_website
        visible_on_bov
        starting_date
        termination_date
        yrs_at_strive
        birth_date
        age
        on_phones
        in_pool
        first_listing
        first_closing
        address
        territory
        w4_form
        w9_form
        payroll_form
        ca_form
        it_policy_form
        trade_secrets_form
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
        Investors {
        contact_id
        contact_type
        arcimedes_row_id
        first_name
        last_name
        phone
        cell_phone
        email
        firm
        agent
        agent_firm
        status
        company_name
        company_address
        company_city
        company_state
        company_zip
        type
           notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
        profile
        category
        single_tenant_subcategory
        multi_tenant_subcategory
        market
        price_min
        price_max
        cap_rate_min
        cap_rate_max
        strive_agent
        strive_agent_last_name
        last_modified
        deleted
        hsc_follow_up
        name
        city
        state
        contact_name
        contact_phone
        contact_email
        linkedin
        description
        photo
        credentials
        is_agent
        is_admin
        visible_on_website
        visible_on_bov
        starting_date
        termination_date
        yrs_at_strive
        birth_date
        age
        on_phones
        in_pool
        first_listing
        first_closing
        address
        territory
        w4_form
        w9_form
        payroll_form
        ca_form
        it_policy_form
        trade_secrets_form
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      Teams {
        contact_id
        contact_type
        arcimedes_row_id
        first_name
        last_name
        phone
        cell_phone
        email
        firm
        agent
        agent_firm
        status
        company_name
        company_address
        company_city
        company_state
        company_zip
        type
           notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
        profile
        category
        single_tenant_subcategory
        multi_tenant_subcategory
        market
        price_min
        price_max
        cap_rate_min
        cap_rate_max
        strive_agent
        strive_agent_last_name
        last_modified
        deleted
        hsc_follow_up
        name
        city
        state
        contact_name
        contact_phone
        contact_email
        linkedin
        description
        photo
        credentials
        is_agent
        is_admin
        visible_on_website
        visible_on_bov
        starting_date
        termination_date
        yrs_at_strive
        birth_date
        age
        on_phones
        in_pool
        first_listing
        first_closing
        address
        territory
        w4_form
        w9_form
        payroll_form
        ca_form
        it_policy_form
        trade_secrets_form
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      Lenders {
        contact_id
        contact_type
        arcimedes_row_id
        first_name
        last_name
        phone
        cell_phone
        email
        firm
        agent
        agent_firm
        status
        company_name
        company_address
        company_city
        company_state
        company_zip
        type
           notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
        profile
        category
        single_tenant_subcategory
        multi_tenant_subcategory
        market
        price_min
        price_max
        cap_rate_min
        cap_rate_max
        strive_agent
        strive_agent_last_name
        last_modified
        deleted
        hsc_follow_up
        name
        city
        state
        contact_name
        contact_phone
        contact_email
        linkedin
        description
        photo
        credentials
        is_agent
        is_admin
        visible_on_website
        visible_on_bov
        starting_date
        termination_date
        yrs_at_strive
        birth_date
        age
        on_phones
        in_pool
        first_listing
        first_closing
        address
        territory
        w4_form
        w9_form
        payroll_form
        ca_form
        it_policy_form
        trade_secrets_form
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      Tenants {
        contact_id
        contact_type
        arcimedes_row_id
        first_name
        last_name
        phone
        cell_phone
        email
        firm
        agent
        agent_firm
        status
        company_name
        company_address
        company_city
        company_state
        company_zip
        type
           notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
        profile
        category
        single_tenant_subcategory
        multi_tenant_subcategory
        market
        price_min
        price_max
        cap_rate_min
        cap_rate_max
        strive_agent
        strive_agent_last_name
        last_modified
        deleted
        hsc_follow_up
        name
        city
        state
        contact_name
        contact_phone
        contact_email
        linkedin
        description
        photo
        credentials
        is_agent
        is_admin
        visible_on_website
        visible_on_bov
        starting_date
        termination_date
        yrs_at_strive
        birth_date
        age
        on_phones
        in_pool
        first_listing
        first_closing
        address
        territory
        w4_form
        w9_form
        payroll_form
        ca_form
        it_policy_form
        trade_secrets_form
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
        Vendors {
      contact_id
      contact_type
      arcimedes_row_id
      first_name
      last_name
      phone
      cell_phone
      email
      firm
      agent
      agent_firm
      status
      company_name
      company_address
      company_city
      company_state
      company_zip
      type
         notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      profile
      category
      single_tenant_subcategory
      multi_tenant_subcategory
      market
      price_min
      price_max
      cap_rate_min
      cap_rate_max
      strive_agent
      strive_agent_last_name
      last_modified
      deleted
      hsc_follow_up
      name
      city
      state
      contact_name
      contact_phone
      contact_email
      linkedin
      description
      photo
      credentials
      is_agent
      is_admin
      visible_on_website
      visible_on_bov
      starting_date
      termination_date
      yrs_at_strive
      birth_date
      age
      on_phones
      in_pool
      first_listing
      first_closing
      address
      territory
      w4_form
      w9_form
      payroll_form
      ca_form
      it_policy_form
      trade_secrets_form
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
      title
      zip
      recipient_id
      user_type
      vendor_type
      website
    }
    }
  }
`

export const GET_CONTACT_LIST_QUERY = gql`
query GetContacts($type: String,$startsWith: String,$loginUserId:String, $sortOptions: [SortOptions], $filters: [ContactsFilters], $pageOptions: PageOptions) {
  getContacts(type: $type,startsWith: $startsWith,loginUserId:$loginUserId, sortOptions: $sortOptions, filters: $filters, pageOptions: $pageOptions) {
    success
    message
    data {
      contact_id
      contact_type
      arcimedes_row_id
      first_name
      last_name
      phone
      cell_phone
      email
      firm
      agent
      agent_firm
      status
      company_name
      company_address
      company_city
      company_state
      company_zip
      type
       notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      profile
      category
      single_tenant_subcategory
      multi_tenant_subcategory
      market
      price_min
      price_max
      cap_rate_min
      cap_rate_max
      strive_agent
      strive_agent_last_name
      last_modified
      deleted
      hsc_follow_up
      name
      city
      state
      contact_name
      contact_phone
      contact_email
      linkedin
      description
      photo
      credentials
      is_agent
      is_admin
      visible_on_website
      visible_on_bov
      starting_date
      termination_date
      yrs_at_strive
      birth_date
      age
      on_phones
      in_pool
      first_listing
      first_closing
      address
      territory
      w4_form
      w9_form
      payroll_form
      ca_form
      it_policy_form
      trade_secrets_form
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    totalCount
    error
  }
}

`

export const GET_CONTACT_AGENTS_LIST_QUERY = gql`
query GetContacts($type: String, $pageOptions: PageOptions, $filters: [ContactsFilters], $sortOptions: [SortOptions]) {
  getContacts(type: $type, pageOptions: $pageOptions, filters: $filters, sortOptions: $sortOptions) {
    success
    message
    data {
      first_name
      last_name
      email
      phone
      cell_phone
      firm
      address
      city
      state
      zip
      contact_id
      contact_type
      arcimedes_row_id
      agent_firm
      company_address
      company_city
      company_state
      company_zip
    }
    totalCount
    error
  }
}
`
export const GET_CONTACT_VENDORS_LIST_QUERY = gql`
query GetContacts($type: String, $pageOptions: PageOptions, $filters: [ContactsFilters], $sortOptions: [SortOptions]) {
  getContacts(type: $type, pageOptions: $pageOptions, filters: $filters, sortOptions: $sortOptions) {
    success
    message
    data {
      contact_id
      contact_type
      arcimedes_row_id
      first_name
      last_name
      phone
      cell_phone
      email
      firm
      agent
      agent_firm
      status
      company_name
      company_address
      company_city
      company_state
      company_zip
      type
      notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      profile
      category
      single_tenant_subcategory
      multi_tenant_subcategory
      market
      price_min
      price_max
      cap_rate_min
      cap_rate_max
      strive_agent
      strive_agent_last_name
      last_modified
      deleted
      hsc_follow_up
      name
      city
      state
      contact_name
      contact_phone
      contact_email
      linkedin
      description
      photo
      credentials
      is_agent
      is_admin
      visible_on_website
      visible_on_bov
      starting_date
      termination_date
      yrs_at_strive
      birth_date
      age
      on_phones
      in_pool
      first_listing
      first_closing
      address
      territory
      w4_form
      w9_form
      payroll_form
      ca_form
      it_policy_form
      trade_secrets_form
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
      title
      zip
      recipient_id
      user_type
      vendor_type
      website
    }
    totalCount
    error
  }
}
`
export const GET_CONTACT_SELLERS_LIST_QUERY = gql`
query GetContacts($type: String, $sortOptions: [SortOptions], $filters: [ContactsFilters], $pageOptions: PageOptions) {
  getContacts(type: $type, sortOptions: $sortOptions, filters: $filters, pageOptions: $pageOptions) {
    success
    message
    data {
      status
     first_name
     last_name
      email
      phone
      company_name
      profile
      company_address
      company_city
      company_state
      company_zip
      contact_id
      contact_type
      arcimedes_row_id
    }
    totalCount
    error
  }
}

`
//this fields removed in the above query for unwanted dat coming in the export api
// city
// state
//company_phone
//name
//notes
export const GET_CONTACT_LENDERS_LIST_QUERY = gql`
query GetContacts($type: String, $sortOptions: [SortOptions], $filters: [ContactsFilters], $pageOptions: PageOptions) {
  getContacts(type: $type, sortOptions: $sortOptions, filters: $filters, pageOptions: $pageOptions) {
    success
    message
    data {
      name
      city
      state
      contact_name
      contact_phone
      cell_phone
      email
      address
      zip
      contact_id
      contact_type
      arcimedes_row_id
      first_name
      last_name
      company_name
      company_address
      company_city
      company_state
      company_zip
    }
    totalCount
    error
  }
}

`
//this all are removed from above lenders query
// first_name
// last_name
// phone
// cell_phone
// email
// notes
// agent
// agent_firm

export const GET_BUYER_LIST_QUERY = gql`
query GetContacts($type: String, $sortOptions: [SortOptions], $filters: [ContactsFilters], $pageOptions: PageOptions) {
  getContacts(type: $type, sortOptions: $sortOptions, filters: $filters, pageOptions: $pageOptions) {
    success
    message
    data {
     contact_id
     arcimedes_row_id
        status
        category
        type
        single_tenant_subcategory
        multi_tenant_subcategory
        market
        price_min
        price_max
        cap_rate_min
        cap_rate_max
        first_name
        last_name
        email
        phone
        company_name
        strive_agent
        strive_agent_last_name
        company_address
        company_city
        company_state
        company_zip 
        profile
     contact_type
deleted
    }
    totalCount
    error
  }
}
`;
export const GET_BUYER_DD_QUERY = gql`
query GetContacts($type: String, $sortOptions: [SortOptions], $filters: [ContactsFilters], $pageOptions: PageOptions) {
  getContacts(type: $type, sortOptions: $sortOptions, filters: $filters, pageOptions: $pageOptions) {
    success
    message
    data {
     contact_id
     arcimedes_row_id
        status
        type
        first_name
        last_name
        company_name
     contact_type
deleted
    }
    totalCount
    error
  }
}
`;
export const GET_INVESTOR_LIST_QUERY = gql`
query GetContacts($type: String, $sortOptions: [SortOptions], $filters: [ContactsFilters], $pageOptions: PageOptions) {
  getContacts(type: $type, sortOptions: $sortOptions, filters: $filters, pageOptions: $pageOptions) {
    success
    message
    data {
     contact_id
     arcimedes_row_id
        status
        category
        type
        single_tenant_subcategory
        multi_tenant_subcategory
        market
        price_min
        price_max
        cap_rate_min
        cap_rate_max
        first_name
        last_name
        email
        phone
        cell_phone
        company_name
        strive_agent
        strive_agent_last_name
        company_address
        company_city
        company_state
        company_zip
        profile
       contact_type
       deleted
       date_of_down_leg
    }
    totalCount
    error
  }
}
`;

export const GET_PROPERTIES_BY_INVESTOR_ID = gql`
  query InvestorProperties($investor_id: ID!, $pageOptions: PageOptions) {
    getpropertiesByInvestorId(investor_id: $investor_id, pageOptions: $pageOptions) {
      activeTotalCount
      closedTotalCount
      historicalTotalCount
      active {
        arcimedes_row_id
        name
        status
        address
        city
        state
        list_price
        category
        type
        seller_id
        buyer_id
        close_of_escrow
      }
      closed {
        arcimedes_row_id
        name
        status
        sold_price
        close_of_escrow
        address
        city
        state
        list_price
        category
        type
        seller_id
        buyer_id
      }
      historical {
        arcimedes_row_id
        name
        status
        sold_price
        close_of_escrow
        address
        city
        state
        list_price
        category
        type
        seller_id
        buyer_id
        is_past_ownership
        history_ownership_role
        ownership_history_date
      }
    }
  }
`;
//this all are removed from above buyers query
// agent
// agent_firm
// deleted
// arcimedes_created
// arcimedes_created_by
// arcimedes_modified
// arcimedes_modified_by
// notes
// name
// cell_phone
export const GET_CONTACT_TEAM_LIST_QUERY = gql`
  query GetContacts(
    $type: String
    $sortOptions: [SortOptions]
    $filters: [ContactsFilters]
    $pageOptions: PageOptions
  ) {
    getContacts(
      type: $type
      sortOptions: $sortOptions
      filters: $filters
      pageOptions: $pageOptions
    ) {
      success
      message
      data {
        is_agent
        first_name
        last_name
        phone
        cell_phone
        starting_date
        yrs_at_strive
        birth_date
        on_phones
        in_pool
        first_listing
        first_closing
        address
        email
        state
        city
        zip
        contact_id
        arcimedes_row_id
        termination_date
     contact_type
     deleted
     name
     notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
     arcimedes_modified
      }

      totalCount
      error
    }
  }
`;
//this all are removed from above teams query
// name
// arcimedes_created
// arcimedes_created_by
// arcimedes_modified
// arcimedes_modified_by
// deleted
// linkedin
// w4_form
// w9_form
// payroll_form
// ca_form
// it_policy_form
// trade_secrets_form
// description
// photo
// credentials
// visible_on_website
// visible_on_bov
// age
// territory
// title
//is_admin


export const GET_CONTACT_TENANTS_LIST_QUERY = gql`
query GetContacts($type: String, $sortOptions: [SortOptions], $filters: [ContactsFilters], $pageOptions: PageOptions) {
  getContacts(type: $type, sortOptions: $sortOptions, filters: $filters, pageOptions: $pageOptions) {
    success
    message
    data {
    deleted
            name
            first_name
            last_name
            notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
            address
            city
            state
            zip
            contact_id
            arcimedes_row_id
            contact_type
             
    }
    totalCount
    error
  }
}
`

export const GET_TENANTS_PROPERTY_LIST_QUERY = gql`
query GetContacts($type: String, $sortOptions: [SortOptions], $filters: [ContactsFilters], $pageOptions: PageOptions) {
  getContacts(type: $type, sortOptions: $sortOptions, filters: $filters, pageOptions: $pageOptions) {
    success
    message
    data {
            deleted
            name
            first_name
            last_name
            contact_id
            arcimedes_row_id             
    }
    totalCount
    error
  }
}
`

//this all are removed from above tenants query
// arcimedes_created
// arcimedes_created_by
// arcimedes_modified
// arcimedes_modified_by
//deleted
//first_name
//last_name
export const GET_CONTACT_TENANTS_BY_ID = gql`
query GetContactByContactid($contactid: Float) {
  getContactByContactid(contactid: $contactid) {
    contact {
      contact_type
     arcimedes_row_id
        name
        deleted
        address
        city
        state
        zip
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
        contact_id
        first_name
        last_name
        notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
        cell_phone
        email
    }
    error
    message
    success
  }
}
`
export const GET_CONTACT_TEAM_BY_ID = gql`
query GetContactByContactid($contactid: Float) {
  getContactByContactid(contactid: $contactid) {
    contact {
      contact_id
      contact_type
      arcimedes_row_id
      first_name
      last_name
      phone
      cell_phone
      email
      firm
      agent
      agent_firm
      status
      company_name
      company_address
      company_city
      company_state
      company_zip
      type
       notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      profile
      category
      single_tenant_subcategory
      multi_tenant_subcategory
      market
      price_min
      price_max
      cap_rate_min
      cap_rate_max
      strive_agent
      strive_agent_last_name
      last_modified
      deleted
      hsc_follow_up
      name
      city
      state
      contact_name
      contact_phone
      contact_email
      linkedin
      description
      photo
      credentials
      is_agent
      is_admin
      visible_on_website
      visible_on_bov
      starting_date
      termination_date
      yrs_at_strive
      birth_date
      age
      on_phones
      in_pool
      first_listing
      first_closing
      address
      territory
      w4_form
      w9_form
      payroll_form
      ca_form
      it_policy_form
      trade_secrets_form
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
      title
      zip
      hsc_id
      re_license_form
    }
    error
    message
    success
  }
}
`
export const GET_CONTACT_TEAM_BY_ARCIMEDES_ID = gql`
query getContactTeamByArcId($arcimedes_row_id: ID!) {
  getContactTeamByArcId(arcimedes_row_id: $arcimedes_row_id) {
    contact {
      contact_id
      contact_type
      arcimedes_row_id
      first_name
      last_name
      phone
      cell_phone
      email
      firm
      agent
      agent_firm
      status
      company_name
      company_address
      company_city
      company_state
      company_zip
      type
      notes
      profile
      category
      single_tenant_subcategory
      multi_tenant_subcategory
      market
      price_min
      price_max
      cap_rate_min
      cap_rate_max
      strive_agent
      strive_agent_last_name
      last_modified
      deleted
      hsc_follow_up
      name
      city
      state
      contact_name
      contact_phone
      contact_email
      linkedin
      description
      photo
      credentials
      is_agent
      is_admin
      visible_on_website
      visible_on_bov
      starting_date
      termination_date
      yrs_at_strive
      birth_date
      age
      on_phones
      in_pool
      first_listing
      first_closing
      address
      territory
      w4_form
      w9_form
      payroll_form
      ca_form
      it_policy_form
      trade_secrets_form
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
      title
      zip
    }
    error
    message
    success
  }
}
`
export const GET_CONTACT_BUYER_BY_ID = gql`
query GetContactByContactid($contactid: Float) {
  getContactByContactid(contactid: $contactid) {
    contact {
      contact_type
   arcimedes_row_id
        status
        agent
        agent_firm
        first_name
        last_name
        company_name
        company_address
        company_city
        company_state
        company_zip
        phone
        email
        notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
        profile
        category
        type
        single_tenant_subcategory
        multi_tenant_subcategory
        market
        price_min
        price_max
        cap_rate_min
        cap_rate_max
        strive_agent
        strive_agent_last_name
        cell_phone
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      contact_id
      name
    }
    error
    message
    success
  }
}
`
export const GET_CONTACT_VENDOR_BY_ID = gql`
query GetContactByContactid($contactid: Float) {
  getContactByContactid(contactid: $contactid) {
    success
    message
    contact {
      contact_id
      contact_type
      arcimedes_row_id
      first_name
      last_name
      phone
      cell_phone
      email
      company_name
      company_address
      company_city
      company_state
      company_zip
      type
       notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      deleted
      name
      city
      state
      contact_name
      contact_phone
      contact_email
      address
      zip
      recipient_id
      user_type
      vendor_type
      website
    }
    error
    types
  }
}
`
export const GET_CONTACT_INVESTOR_BY_ID = gql`
query GetContactByContactid($contactid: Float) {
  getContactByContactid(contactid: $contactid) {
    success
    message
    contact {
      contact_id
      contact_type
      arcimedes_row_id
      first_name
      last_name
      phone
      cell_phone
      email
      firm
      agent
      agent_firm
      status
      company_name
      company_address
      company_city
      company_state
      company_zip
      type
     notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      profile
      category
      single_tenant_subcategory
      multi_tenant_subcategory
      market
      price_min
      price_max
      cap_rate_min
      cap_rate_max
      strive_agent
      strive_agent_last_name
      last_modified
      deleted
      hsc_follow_up
      name
      city
      state
      contact_name
      contact_phone
      contact_email
      linkedin
      description
      photo
      credentials
      is_agent
      is_admin
      visible_on_website
      visible_on_bov
      starting_date
      termination_date
      yrs_at_strive
      birth_date
      age
      on_phones
      in_pool
      first_listing
      first_closing
      address
      territory
      w4_form
      w9_form
      payroll_form
      ca_form
      it_policy_form
      trade_secrets_form
      title
      zip
      arcimedes_modified
      hsc_id
      website
      arcimedes_modified_by
      date_of_down_leg
    }
    error
  }
}`
export const GET_AGENT_BY_CONTACTID = gql`
query getContactByContactid($contactid: Float) {
  getContactByContactid(contactid: $contactid) {
    success
    message
    contact {
      contact_id
      contact_type
      arcimedes_row_id
        first_name
        last_name
        phone
        cell_phone
        email
        firm 
        deleted
        address
        city
        state
        zip
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
        name
        notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
        hsc_id
        company_address
        company_city
        company_state
        company_zip
        website
    }
    error
  }
}
`

export const GET_LENDER_BY_CONTACTID = gql`
query getContactByContactid($contactid: Float) {
  getContactByContactid(contactid: $contactid) {
    success
    message
    contact {
      contact_id
      contact_type
      arcimedes_row_id
      name
      city
      state
      contact_name
      contact_phone
      contact_email
      first_name
      last_name
      phone
      cell_phone
      email
       notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      deleted
      address
      city
      state
      zip
      cell_phone
      company_name
      company_address
      company_city
      company_state
      company_zip
      website
      arcimedes_modified_by
      arcimedes_modified
      hsc_id
    }
    error
  }
}
`

export const GET_SELLER_BY_CONTACTID = gql`
query getContactByContactid($contactid: Float) {
  getContactByContactid(contactid: $contactid) {
    success
    message
    contact {
       contact_id
      contact_type
      arcimedes_row_id
      first_name
      last_name
      phone
      cell_phone
      email
      status
      company_name
      company_address
      profile
      city
      state
      company_city
      company_state
      company_zip
      notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      deleted
      name
      website
    }
    error
  }
}
`
export const GET_CONTACT_NOTES_BY_ID = gql`
query GetContactNotesByContactId($contactId: String!) {
  getContactNotesByContactId(contact_id: $contactId) {
    arcimedes_row_id
    text
    date
    user_name
    user_id
    contact_id
    deleted
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`

export const GET_CONTACTS_TEAM_FOR_RECEIPENTS = gql`
query GetEmailMergeContacts {
  getEmailMergeContacts {
    success
    message
    data {
      user_type
      email
      name
      recipient_id
    }
    error
    totalCount
  }
}
  `
  
  export const GET_DUPLICATE_CONTACTS_LIST = gql`
query GetDuplicateContacts($name: String!,$sortOptions: [SortOptions]) {
  getDuplicateContacts(name: $name,sortOptions: $sortOptions) {
    Agents {
      first_name
     last_name
     email
     phone
    cell_phone
      firm
      address
      city
      state
      zip
     contact_id
     contact_type
     arcimedes_row_id
     firm_id
    }
    Teams {
     is_agent
        first_name
        last_name
        phone
        cell_phone
        starting_date
        yrs_at_strive
        birth_date
        on_phones
        in_pool
        first_listing
        first_closing
        address
        state
        city
        zip
        contact_id
        arcimedes_row_id
     contact_type
     name
     notes
    }
    Lenders {
       name
      city
      state
      contact_name
      contact_phone
      contact_email
      address
      zip
      contact_id
      contact_type
      arcimedes_row_id
      first_name
      last_name
      email
    }
    Tenants {
            name
            first_name
            last_name
            notes
            address
            city
            state
            zip
            contact_id
            arcimedes_row_id
            contact_type
    }
    Investors {
       contact_id
     arcimedes_row_id
        status
        category
        type
        single_tenant_subcategory
        multi_tenant_subcategory
        market
        price_min
        price_max
        cap_rate_min
        cap_rate_max
        first_name
        last_name
        email
        phone
        cell_phone
        company_name
        strive_agent
        strive_agent_last_name
        company_address
        company_city
        company_state
        company_zip 
        profile
       contact_type
    }
       Vendors {
      contact_id
      contact_type
      arcimedes_row_id
      first_name
      last_name
      phone
      cell_phone
      email
      firm
      firm_id
      agent
      agent_firm
      status
      company_name
      company_address
      company_city
      company_state
      company_zip
      type
      notes
      deleted
      name
      city
      state
      contact_name
      contact_phone
      contact_email
      linkedin
      description
      photo
      credentials
      is_agent
      is_admin
      address
      zip
      vendor_type
    }
  }
}
`


export const GET_CONTACT_VENDORS_LOI = gql`
query GetContacts($type: String, $filters: [ContactsFilters]) {
  getContacts(type: $type, filters: $filters) {
    success
    message
    data {
      contact_id
      contact_type
      first_name
      last_name
      phone
      vendor_type
      company_name
      createdfromloi
      email
      company_city
      company_state
      company_zip
      company_address
    }
    totalCount
    error
  }
}
`


export const GET_ALL_CAD_LINKS = gql`
query GetAllCadSites {
  getAllCadSites {
    success
    message
    cadSites {
      id
      county
      site_url
      region
      clerks_url
    }
    error
  }
}
`

export const EXPORT_CONTACTS = gql`
  query ExportContacts($type: String!) {
    exportContacts(type: $type) {
      success
      message
      type
      filename
      totalCount
      mimeType
      fileBase64
    }
  }
`;